import { Text } from "@a7y/tailwind-catalyst";

export function Section({
  title,
  icon,
  children,
}: {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <div className="rounded-lg bg-white dark:bg-zinc-800 p-6 shadow-sm ring-1 ring-zinc-200 dark:ring-zinc-700">
      <div className="mb-4 flex items-center gap-2">
        <span className="text-zinc-950 dark:text-white">{icon}</span>
        <span className="text-base font-semibold text-zinc-950 dark:text-white">{title}</span>
      </div>
      {children}
    </div>
  );
}

export function UsageStat({
  label,
  current,
  limit,
}: {
  label: string;
  current: number;
  limit: number;
}) {
  const isUnlimited = limit === -1;
  const percentage = isUnlimited ? 0 : limit > 0 ? Math.min((current / limit) * 100, 100) : 0;
  const isOverLimit = !isUnlimited && limit > 0 && current > limit;

  return (
    <div className="rounded-lg bg-zinc-50 dark:bg-zinc-700 p-4">
      <Text className="text-sm text-zinc-500 dark:text-zinc-400">{label}</Text>
      <Text className="mt-1 text-2xl font-semibold text-zinc-950 dark:text-white">{current}</Text>
      <Text className="text-sm text-zinc-400">
        {isUnlimited ? "Unlimited" : `of ${limit}`}
      </Text>
      {!isUnlimited && limit > 0 && (
        <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-zinc-200 dark:bg-zinc-600">
          <div
            className={`h-full rounded-full ${isOverLimit ? "bg-red-500" : "bg-indigo-500"}`}
            style={{ width: `${Math.min(percentage, 100)}%` }}
          />
        </div>
      )}
    </div>
  );
}
